import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { MapUtils } from '../../../utility/map-utils.js';
import { isNotNullOrUndefined } from '../../../utility/null-safety.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/data-model.js';
import { OpenAccessProtocol, OpenAccessProtocolType } from './open-access-protocol.js';

/**
 * @deprecated Use EventOpenAccessProtocol instead
 */
export class LimitedUseAccessProtocol extends OpenAccessProtocol {
  static readonly TYPE_ID: string = '789ad1a3a9de410697745d7955898dcc';

  public readonly type: OpenAccessProtocolType = OpenAccessProtocolType.LimitedUses;
  private _uses: number | null;

  constructor(
    public readonly maxUses: number,
    uses: number | null,
  ) {
    super();
    this._uses = uses;
  }

  get uses(): number | null {
    return this._uses;
  }

  get isUsed(): boolean {
    return isNotNullOrUndefined(this._uses) && this._uses >= this.maxUses;
  }

  get $typeId(): string {
    return LimitedUseAccessProtocol.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): LimitedUseAccessProtocol {
    return new LimitedUseAccessProtocol(
        MapUtils.get<number>(map, 'maxUses'),
        MapUtils.getOrNull<number>(map, 'uses'),
    );
  }

  toMap(context: SerializationContext):SerializedData {
    return {
      'type': fromEnumAsString(this.type),
      'maxUses': this.maxUses,
      'uses': this.uses,
    };
  }

  clone(): this {
    return new LimitedUseAccessProtocol(
        this.maxUses,
        this.uses,
    ) as this;
  }

  isSame(other: LimitedUseAccessProtocol): boolean {
    if(other === this) {
      return true;
    }

    return other.maxUses === this.maxUses &&
        other.uses === this.uses;
  }

  applyTemplateChanges(other: this): this {
    return new LimitedUseAccessProtocol(
        other.maxUses,
        this.uses,
    ) as this;
  }

  updateUsage(): void {
    this._uses = Math.min(this.maxUses, (this._uses ?? 0) + 1);
  }

  static verifyType(dm: DataModel): boolean {
    return dm instanceof LimitedUseAccessProtocol;
  }

  static assertType(dm: DataModel): dm is LimitedUseAccessProtocol {
    return dm instanceof LimitedUseAccessProtocol;
  }
}

export class LimitedUseAccessProtocolBuilder extends DataModelBuilder<LimitedUseAccessProtocol> {
  build(context: SerializationContext, map: SerializedData): LimitedUseAccessProtocol {
    return LimitedUseAccessProtocol.fromMap(context, map);
  }
}
